import { MenuBook } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { ConvocationSummary } from 'src/types/convocation-summary';
import { formatDate } from 'src/utils/date';

type SummaryCardProps = {
  convocation: ConvocationSummary;
};

export function SummaryCard({ convocation }: SummaryCardProps) {
  const history = useHistory();
  const handleButtonClick = (
    event: React.MouseEvent,
    action: 'download' | 'access',
  ) => {
    event.stopPropagation();

    if (action === 'download') {
      window.open(convocation.url, '_blank');
    } else if (action === 'access') {
      const {
        market: { slug: marketSlug },
        operation: { slug, hashId },
      } = convocation;
      history.push(`/operacao/${marketSlug}/${slug}/${hashId}`);
    }
  };

  return (
    <Box
      id="summary-card"
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: '#f2f2f2',
            mr: 1,
          }}>
          <MenuBook />
        </Box>
        <Typography variant="subtitle1" fontWeight="bold">
          {convocation.tipodocumento} - {convocation.categoriadocumento}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        fontWeight={600}
        mb={2}>
        {formatDate(convocation.datareferencia)}
      </Typography>
      <Typography variant="body2" color="text.secondary" fontWeight={600}>
        Quórum: {convocation.quorum ?? '-'}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 2, sm: 6 },
          mb: 3,
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'flex-start' },
        }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={1}
          width="100%"
          my={2}>
          <Typography variant="h6" mb={1}>
            Resumo
          </Typography>
          <Typography>{convocation.resumo}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          width: { xs: '100%', sm: 'auto' },
        }}>
        <Button
          variant="contained"
          color="primary"
          onClick={(event) => handleButtonClick(event, 'download')}
          sx={{
            textTransform: 'uppercase',
            width: '100%',
            whiteSpace: 'nowrap',
          }}>
          Baixar Documento
        </Button>
        <Button
          variant="contained"
          onClick={(event) => handleButtonClick(event, 'access')}
          sx={{
            backgroundColor: '#B6B6B6',
            '&:hover': { backgroundColor: '#B6B6B6' },
            textTransform: 'uppercase',
            width: '100%',
          }}>
          Acessar Operação
        </Button>
      </Box>
    </Box>
  );
}
